import axios from "axios";

const rawBase = process.env.REACT_APP_API_URL || "";
const apiBase = rawBase.replace(/\/$/, "");

function resolveRequestUrl(config) {
  if (!config?.url) return "";
  if (String(config.url).startsWith("http")) return String(config.url);
  const base = config.baseURL || apiBase;
  if (!base) return String(config.url);
  const path = String(config.url);
  if (path.startsWith("/")) return `${base.replace(/\/$/, "")}${path}`;
  return `${base.replace(/\/$/, "")}/${path}`;
}

function clearSessionAndRedirectAdmin() {
  try {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  } catch {
    /* ignore */
  }
  if (
    typeof window !== "undefined" &&
    window.location.pathname.startsWith("/admin") &&
    !window.location.pathname.includes("/admin/login") &&
    window.location.pathname !== "/admin"
  ) {
    window.location.href = "/admin";
  }
}

if (apiBase) {
  axios.interceptors.request.use((config) => {
    const fullUrl = resolveRequestUrl(config);
    if (fullUrl && fullUrl.startsWith(apiBase)) {
      const headers = config.headers || (config.headers = {});
      if (!headers["X-Client-Source"] && !headers["x-client-source"]) {
        headers["X-Client-Source"] = "web";
      }
    }
    return config;
  });

  // A 403 is not automatically a dead session: restricted roles (e.g. engineers)
  // legitimately get 403 on endpoints they may not use, and logging them out
  // there would produce a redirect loop. Only sign out when the response
  // actually reports an auth failure - the backend messages are the signal
  // (see middleware/auth.js).
  const SESSION_DEAD_403 = /unauthorized|invalid token|token expired|session expired|deactivated|no longer exists/i;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      const status = error?.response?.status;
      const message = String(error?.response?.data?.message || "");
      if (status === 401 || (status === 403 && SESSION_DEAD_403.test(message))) {
        clearSessionAndRedirectAdmin();
      }
      return Promise.reject(error);
    }
  );
}
